import { render, staticRenderFns } from "./StockMovement.vue?vue&type=template&id=028479dc&"
import script from "./StockMovement.vue?vue&type=script&lang=js&"
export * from "./StockMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockMovement.vue"
export default component.exports